import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-added-to-cart-dialog',
    imports: [],
    template: `
        <div class="dialog ajaxCart">
            <div class="dialogHeader k-window-titlebar k-header">
                <div class="k-window-actions">
                    <a role="button" (click)="dialogRef.close()"> </a>
                </div>
            </div>
            <div class="dialogBody">
                <div class="dialogTitle">Added to Cart</div>
                <div class="dialogMessage">
                    <p>This part was added to your cart</p>
                </div>
                <div class="dialogButtonToolbar">
                    <button type="button" class="dialogButton" (click)="dialogRef.close()">Continue Shopping</button>
                    <button type="button" class="dialogButton" (click)="checkout()">Checkout Now</button>
                </div>
            </div>
        </div>
    `,
    styles: ``
})
export class AddedToCartDialogComponent {
    public dialogRef: DialogRef = inject(DialogRef);
    router = inject(Router);

    checkout() {
        this.dialogRef.close();
        this.router.navigate(['/checkout/cart']);
    }
}
